import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "t2_banner_name" }
const _hoisted_4 = {
  class: "t2-search-form2",
  action: "search"
}
const _hoisted_5 = { class: "form-group" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
let keyWord = ref('')
const search = () => {
    router.push({
        path:'/globalSearch',
        query:{
            keyWord:keyWord.value
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h1", null, "河南自由贸易试验区开封片区", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyWord) ? (keyWord).value = $event : keyWord = $event)),
              onKeyup: _withKeys(search, ["enter"]),
              placeholder: "请输入您要查询的信息或关键字"
            }, null, 544), [
              [_vModelText, _unref(keyWord)]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "t2-btn-search2",
            onClick: search
          }, "搜索")
        ])
      ])
    ])
  ]))
}
}

})